var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 21,
  fill: "none",
  viewBox: "0 0 23 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M4.826.9h13.348a3.92 3.92 0 0 1 2.776 1.168 4 4 0 0 1 1.15 2.8v8.17a4 4 0 0 1-1.147 2.807 3.92 3.92 0 0 1-2.779 1.172h-4.016l-1.822 2.81a.6.6 0 0 1-1.008-.001l-1.822-2.818H4.827A3.94 3.94 0 0 1 2.05 15.84 4.02 4.02 0 0 1 .9 13.039V4.868a4 4 0 0 1 1.15-2.8A3.92 3.92 0 0 1 4.826.9m.002 1.2a2.72 2.72 0 0 0-1.924.811 2.8 2.8 0 0 0-.804 1.96v8.167a2.8 2.8 0 0 0 .804 1.959 2.72 2.72 0 0 0 1.924.81h5.004a.6.6 0 0 1 .504.275l1.497 2.314 1.496-2.306a.6.6 0 0 1 .503-.273h4.34a2.72 2.72 0 0 0 1.926-.814 2.8 2.8 0 0 0 .802-1.964V4.87a2.8 2.8 0 0 0-.804-1.96 2.72 2.72 0 0 0-1.924-.811z",
  clipRule: "evenodd"
})));
export { SvgChat as ReactComponent };